import {
  GET_PLC_POPUP_STATUS,
  GET_PLC_POPUP_STATUS_SUCCESS,
  GET_PLC_POPUP_STATUS_ERROR,
} from "./actionTypes";

const initialState = {
  errorGetPlcPopupStatus: "",
  loadingPlcPopupStatus: false,
  plc_popup_status: null,
  successGetPlcPopupStatus: "",
};

const getPlcPopupStatus = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_POPUP_STATUS:
      state = {
        ...state,
        loadingPlcPopupStatus: true,
      };
      break;
    case GET_PLC_POPUP_STATUS_SUCCESS:
      state = {
        ...state,
        loadingPlcPopupStatus: false,
        plc_popup_status: action.payload.plc_popup_status,
        successGetPlcPopupStatus: action.payload.message,
      };
      break;
    case GET_PLC_POPUP_STATUS_ERROR:
      state = {
        ...state,
        errorGetPlcPopupStatus: action.payload,
        loadingPlcPopupStatus: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getPlcPopupStatus;
